export const productDevelopmentDashboardEn = {
  title: 'Product development',
  subtitle: 'Role-based overview of master data, releases, manufacturing and planning signals.',
  help: 'Open product-development help',
  refresh: 'Refresh dashboard',
  generatedAt: 'Data as of {{date}}',
  loading: {
    title: 'Loading product-development dashboard',
    description: 'The current workflow and planning signals are being calculated.',
  },
  error: {
    title: 'Dashboard could not be loaded',
    description: 'The server could not calculate the current product-development signals.',
    retry: 'Try again',
  },
  empty: {
    title: 'No role-specific metrics available',
    description: 'Your role currently has no read access to the dashboard data domains.',
  },
  cards: {
    OPEN_WORKFLOWS: {
      title: 'Open reviews and approvals',
      description: 'Items that require an explicit professional decision.',
    },
    INCOMPLETE_MATERIALS: {
      title: 'Incomplete raw materials',
      description: 'Latest profiles without approval, supplier data or declaration names.',
    },
    DECLARATION_WARNINGS: {
      title: 'Declaration warnings',
      description:
        'Latest declarations with validation issues, discrepancies or missing languages.',
    },
    EXPIRING_VERSIONS: {
      title: 'Expiring versions',
      description: 'Approved source versions that expire within 30 days.',
    },
    UPCOMING_PRODUCTION_ORDERS: {
      title: 'Upcoming production orders',
      description: 'Planned or released orders starting within 14 days.',
    },
    MATERIAL_SHORTAGES: {
      title: 'Material shortages',
      description: 'Open suggestions from the latest reproducible MRP run.',
    },
    PRODUCTION_DEVIATIONS: {
      title: 'Production deviations',
      description: 'Recent completions with an exact yield or consumption difference.',
    },
  },
  workflows: {
    title: 'Reviews and approvals',
    subtitle: 'Only queues for actions allowed by your role are shown.',
    review: 'Review',
    approval: 'Approval',
    open: 'Open queue',
    none: 'No actionable workflow queues are assigned to your role.',
  },
  queues: {
    MATERIALS: 'Material profiles',
    RECIPES: 'Recipes and BOMs',
    PROCESS_ROUTINGS: 'Process routings',
    DECLARATIONS: 'Declarations',
    ANALYSIS: 'Analysis profiles',
    SPECIFICATIONS: 'Product specifications',
    LABELS: 'Label templates',
    CHANGE_REQUESTS: 'Change requests',
  },
  recentRecipes: {
    title: 'Recently changed recipes',
    subtitle: 'The latest edited version of each recipe visible to your role.',
    empty: 'No recipe versions are available.',
    number: 'Number',
    name: 'Recipe',
    product: 'Output product',
    version: 'Version',
    status: 'Status',
    changed: 'Changed',
    open: 'Open recipe {{number}}',
  },
  deviations: {
    title: 'Yield and consumption deviations',
    subtitle:
      'Recent completed orders; percentages are calculated server-side with exact decimals.',
    empty: 'No differences were recorded in the current 30-day period.',
    order: 'Order',
    product: 'Product',
    plannedActual: 'Planned / actual',
    yield: 'Output deviation',
    material: 'Largest material deviation',
    reported: 'Reported',
    unbounded: 'Unbounded (consumption against zero plan)',
    open: 'Open production order {{number}}',
  },
  recipeStatuses: {
    DRAFT: 'Draft',
    IN_REVIEW: 'In review',
    APPROVED: 'Approved',
    BLOCKED: 'Blocked',
    ARCHIVED: 'Archived',
  },
} as const;
